module.exports = __webpack_public_path__ + "img/组 48.1f463b4b.png";